import { getData, putData } from "../api/api";

export type OpenSearchIndexPolicySettings = {
  enforceAllowlist: boolean;
  allowedIndices: string[];
  allowedPrefixes: string[];
  lastModifiedDate?: string;
  lastModifiedBy?: string;
};

export const adminOpenSearchPolicyService = {
  getSettings: () =>
    getData("/admin/opensearch-policy") as Promise<OpenSearchIndexPolicySettings>,

  saveSettings: (settings: Pick<OpenSearchIndexPolicySettings, "enforceAllowlist" | "allowedIndices" | "allowedPrefixes">) =>
    putData("/admin/opensearch-policy", settings) as Promise<OpenSearchIndexPolicySettings>,
};
